import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-p2-stat-source',
  templateUrl: './p2-stat-source.component.html',
  styleUrls: ['./p2-stat-source.component.css']
})
export class P2StatSourceComponent implements OnInit {
    public itemsListStatSources: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {

    }

    private async loadStatSources(): Promise<void> {
        this.itemsListStatSources = await this.datatask.Post(810);
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'p2statsourceedit':
                this.stateService?.go('p2statsourceedit', { p2_statsource_keyno: '0' });
                break;
            default:
                break;
        }
    }

    private async init() {
        this.loadStatSources();
    }

    ngOnInit() {
        this.init();
    }
}



//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('p2StatSource', {
//        templateUrl: 'views/components/views/p2StatSource/p2StatSource.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'p2StatSourceService', function (stateService, p2StatSourceService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                itemsListStatSources: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            let loadStatSources = function () {
//                p2StatSourceService.listStatSources().then(function (list) {
//                    angular.copy(list, vm.model.itemsListStatSources);
//                });
//            };

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                let go = function (parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'p2statsourceedit':
//                        go({ p2_statsource_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadStatSources();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
